module.exports = __webpack_public_path__ + "static/media/set4.587dd1d2.png";